import { CtaHeroBlockData } from 'api/cms';
import { AmpHeroBlock } from 'cms/blocks/Amp/AmpHeroBlock';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { CtaHeroBlock } from './CtaHeroBlock';

export const CtaHeroBlockMapping: BlockMapping<CtaHeroBlockData> = {
  invariant: [
    {
      prop: 'text',
      msg: 'Text data required for call to action',
    },
    {
      prop: 'image',
      msg: 'Image data required for call to action',
    },
  ],
  width: 'FULL',
  Component: CtaHeroBlock,
  AmpComponent: AmpHeroBlock,
};
